import { httpClient } from "./httpClient";

  const getAllAdminLentCars = () => {
    return httpClient.get("admin_lent_cars");
  };
  
  export default {
    getAllAdminLentCars,
  };